import { ThemeOptions } from '@mui/material';
import { indigo } from '@mui/material/colors';

const theme: ThemeOptions = {
  palette: {
    primary: {
      light: '#7FC28C',
      main: '#409582',
      dark: '#7FC28C',
      contrastText: '#fff',
    },
    secondary: {
      light: indigo[300],
      main: indigo[500],
      dark: indigo[700],
      contrastText: '#fff',
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        fullWidth: true,
      },
    },
    MuiButton: {
      defaultProps: {},
    },
    MuiLink: {
      defaultProps: {
        color: '#409582',
      },
      styleOverrides: {
        root: {
          ':visited': {
            color: '#409582',
          },
        },
      },
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
};

export default theme;
